import React, { useState } from 'react'
import {Form, Button} from "react-bootstrap";
import axios from 'axios';
import {useTranslation} from "react-i18next";
import './Login.css'
import i18n from "../i18n";

function Register(){
    const [errorInfo, setErrorInfo] = useState(<div></div>);
    const [errorText, setErrorText] = useState("");
    const [enabledButton, setEnabledButton] = useState(true);
    const [isAstra, setIsAstra] = useState(process.env.REACT_APP_SERVICE == 'astra');

    const { t } = useTranslation(['register', 'base']);

    function submitForm(event){
        event.preventDefault()
        setEnabledButton(false);

        axios.post('api/user/register', { email: event.target[0].value, password: event.target[1].value, forgotPassword: event.target[2].value})
            .then(response => {console.log(response); window.location = "/confirm-email"; setEnabledButton(true)})
            .catch((error) => {
                console.log(error.response);
                setErrorInfo(<div style={{color: "red", paddingTop: "10px"}}>Such an email already exists, or different passwords have been entered.</div>)
                if(error.response.status === 400){
                    setErrorText(error.response.data);
                    console.log(error.response.data);
                }

                setEnabledButton(true)
            });
    }

    return(
        <div className='login'>
            <div className='login-container'>
                { isAstra ? <div className='console-logo'><img className='astra-icon' src="/image/astra/astra_logo.svg"/></div> : <div className='console-logo'>Air-link Console</div>}
                <Form onSubmit={submitForm}>
                    <Form.Group className="login-form" controlId="formBasicEmail">
                        <Form.Label>{t('address', { ns: "register"})}</Form.Label>
                        <Form.Control type="email" placeholder="Enter email" />
                        <Form.Text className="text-muted">
                        
                        </Form.Text>
                    </Form.Group>

                    <Form.Group className="login-form" controlId="formBasicPassword">
                        <Form.Label>{t('password', { ns: "register"})}</Form.Label>
                        <Form.Control type="password" placeholder="Password" />
                    </Form.Group>
                    <Form.Group className="login-form" controlId="formBasicPassword">
                        <Form.Label>{t('password', { ns: "register"})}</Form.Label>
                        <Form.Control type="password" placeholder="Password" />
                    </Form.Group>
                    <Button variant="light" type="submit" disabled={!enabledButton}>
                        {t('Register', { ns: "base"})}
                    </Button>
                </Form>
                <div style={{color: "red", paddingTop: "10px"}}>{t(errorText, { ns: "register"})}</div>
            </div>
        </div>
    )
}

export default Register;
